import { useState } from 'react'
import { ESTADOS_TAREA } from '../../shared/schema'
import { quickUpdate, useRecords } from '../lib/api'
import { useEditor } from '../lib/useOpen'
import { fmtDay, today } from '../lib/format'
import { Kanban } from '../components/Boards'
import { RecordForm } from '../components/RecordForm'
import { Avatar, Badge, Button, ErrorNote, PageHeader, Skeleton, toneOf, useToast } from '../components/ui'

export function Tareas() {
  const { data, loading, error, refresh } = useRecords('tareas')
  const ed = useEditor(data)
  const toast = useToast()
  const [area, setArea] = useState('')
  const [socia, setSocia] = useState('')
  const areas = [...new Set(data.map(t => t.area).filter(Boolean))]
  const list = data.filter(t => (!area || t.area === area) && (!socia || t.socia === socia))
  const t = today()
  return (
    <div className="page">
      <PageHeader eyebrow="Organización" title="Tareas" subtitle="Pendientes de todas las áreas, incluido el plan de desarrollo de la Academia."
        actions={<Button variant="primary" icon="plus" onClick={() => ed.create({ estado: 'Por hacer', area: area || 'General' })}>Nueva tarea</Button>} />
      <div className="toolbar">
        <div className="chips">
          <button type="button" className={`chip ${!area ? 'on' : ''}`} onClick={() => setArea('')}>Todas las áreas</button>
          {areas.map(a => <button type="button" key={a} className={`chip ${area === a ? 'on' : ''}`} onClick={() => setArea(area === a ? '' : a)}>{a}</button>)}
        </div>
        <select id="t-socia" value={socia} onChange={e => setSocia(e.target.value)} aria-label="Socia"><option value="">Ambas socias</option><option>Leticia</option><option>Yesica</option></select>
      </div>
      {error && <ErrorNote error={error} onRetry={refresh} />}
      {loading ? <Skeleton rows={4} /> : (
        <Kanban columns={ESTADOS_TAREA.map(e => ({ key: e, tone: toneOf(e) }))} items={list} groupBy={x => x.estado} onCardClick={ed.open}
          onMove={async (x, e) => { try { await quickUpdate('tareas', x, { estado: e }); toast(`“${x.titulo}” → ${e}`) } catch (err: any) { toast(err.message, 'error') } }}
          render={x => (
            <>
              <span className="ctx-label">{x.area}</span>
              <strong className={x.estado === 'Hecha' ? 'done' : ''}>{x.titulo}</strong>
              <div className="kc-foot">
                <span className={x.vence && x.vence < t && x.estado !== 'Hecha' ? 'overdue-text' : ''}>{x.vence ? fmtDay(x.vence) : 'Sin fecha'}</span>
                {x.prioridad && <Badge>{x.prioridad}</Badge>}<Avatar name={x.socia} />
              </div>
            </>
          )} />
      )}
      <RecordForm col="tareas" open={ed.isOpen} record={ed.editing} defaults={ed.creating ?? undefined} onClose={ed.close} />
    </div>
  )
}
